import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IOuter } from '../EmptyState.types';

export const UnknownErrorTitle: FC<IOuter> = () => <FormattedMessage id="empty-state.server-error-title" />;
